import completePakistanPolygonData from '../../Components/Map/Geojsons/completePakistanPolygonData.geojson';
// export const pakBoundryLayer = (map) => {
//     if(map){
//     const sourceId = "pakistanBoundry";
//     const layerId = "pak-layer-network";

//     map.current.addSource(sourceId, {
//         type: "geojson",
//         data: completePakistanPolygonData,
//     });

//     map.current.addLayer({
//         id: layerId,
//         type: "line",
//         source: sourceId,
//         layout: {
//             "line-join": "round",
//             "line-cap": "round",
//         },
//         paint: {
//             "line-color": "#BD1D23",
//             "line-width": 3,
//             "line-dasharray": [1, 4] // Creates a dotted effect
//         },
//     });

//     function animateFlicker() {
//         let randomOpacity = Math.random() * 0.7 + 0.3; // Random opacity between 0.3 and 1
//         map.current.setPaintProperty(layerId, "line-opacity", randomOpacity);
//         setTimeout(animateFlicker, Math.random() * 500 + 500); // Change every 0.5-1 sec
//     }

//     animateFlicker();
//     console.log("Flickering light effect added!");
// }
// };

//export const pakBoundryLayer = () => {
//     const sourceId = "pakistanBoundry";
//     const layerId = "pak-layer-network";
//     map.current.addSource(sourceId, {
//         type: "geojson",
//         data: completePakistanPolygonData,
//     });

//     map.current.addLayer({
//         id: layerId,
//         type: "line",
//         source: sourceId,
//         layout: {
//             "line-join": "round",
//             "line-cap": "round",
//         },
//         paint: {
//             "line-color": "#BD1D23",
//             "line-width": 3,
//         },
//     });

//     console.log("Network layer added successfully!");
// };

// const pakBoundryLayer = () => {
//     const sourceId = "pakistanBoundry";
//     const layerId = "pak-layer-network";

//     map.current.addSource(sourceId, {
//         type: "geojson",
//         data: completePakistanPolygonData,
//     });

//     map.current.addLayer({
//         id: layerId,
//         type: "line",
//         source: sourceId,
//         layout: {
//             "line-join": "round",
//             "line-cap": "round",
//         },
//         paint: {
//             "line-color": "#BD1D23",
//             "line-width": 3,
//             "line-opacity": 1, // Start at full opacity
//         },
//     });

//     let opacity = 1;
//     let increasing = false;

//     function animateOpacity() {
//         if (increasing) {
//             opacity += 0.02;
//             if (opacity >= 1) increasing = false;
//         } else {
//             opacity -= 0.02;
//             if (opacity <= 0.3) increasing = true;
//         }

//         map.current.setPaintProperty(layerId, "line-opacity", opacity);
//         requestAnimationFrame(animateOpacity);
//     }

//     animateOpacity();
//     console.log("Glowing pulse effect added!");
// };

//export const pakBoundryLayer = () => {
//     const sourceId = "pakistanBoundry";
//     const layerId = "pak-layer-network";

//     map.current.addSource(sourceId, {
//         type: "geojson",
//         data: completePakistanPolygonData,
//     });

//     map.current.addLayer({
//         id: layerId,
//         type: "line",
//         source: sourceId,
//         layout: {
//             "line-join": "round",
//             "line-cap": "round",
//         },
//         paint: {
//             "line-width": 3,
//         },
//     });

//     let colors = ["#FF0000", "#0000FF", "#800080", "#FFFF00", "#FFA500"];
//     let step = 0;

//     function animateColor() {
//         map.current.setPaintProperty(layerId, "line-color", colors[step]);
//         step = (step + 1) % colors.length;
//         setTimeout(animateColor, 1000); // Change color every 1 sec
//     }

//     animateColor();
//     console.log("Color cycling effect added!");
// };

//export const pakBoundryLayer = () => {
//     const sourceId = "pakistanBoundry";
//     const layerId = "pak-layer-network";

//     map.current.addSource(sourceId, {
//         type: "geojson",
//         data: completePakistanPolygonData,
//     });

//     map.current.addLayer({
//         id: layerId,
//         type: "line",
//         source: sourceId,
//         layout: {
//             "line-join": "round",
//             "line-cap": "round",
//         },
//         paint: {
//             "line-color": "#BD1D23",
//             "line-width": 3,
//             "line-dasharray": [2, 4], // Dashed line effect
//         },
//     });

//     let dashArraySequence = [
//         [0, 4, 3],
//         [1, 3, 2],
//         [2, 2, 1],
//         [3, 1, 0],
//         [0, 4, 3], // Loop back
//     ];

//     let step = 0;
//     function animateDashArray() {
//         map.current.setPaintProperty(layerId, "line-dasharray", dashArraySequence[step]);
//         step = (step + 1) % dashArraySequence.length;
//         requestAnimationFrame(animateDashArray);
//     }

//     animateDashArray();
//     console.log("Animated dashed boundary added!");
// };
// const pakBoundryLayer = () => {
//     const sourceId = "pakistanBoundry";
//     const layerId = "pak-layer-network";

//     map.current.addSource(sourceId, {
//         type: "geojson",
//         data: completePakistanPolygonData,
//     });

//     map.current.addLayer({
//         id: layerId,
//         type: "line",
//         source: sourceId,
//         layout: {
//             "line-join": "round",
//             "line-cap": "round",
//         },
//         paint: {
//             "line-color": "#BD1D23",
//             "line-width": 3,
//             "line-dasharray": [1, 4] // Creates a dotted effect
//         },
//     });

//     function animateFlicker() {
//         let randomOpacity = Math.random() * 0.7 + 0.3; // Random opacity between 0.3 and 1
//         map.current.setPaintProperty(layerId, "line-opacity", randomOpacity);
//         setTimeout(animateFlicker, Math.random() * 500 + 500); // Change every 0.5-1 sec
//     }

//     animateFlicker();
//     console.log("Flickering light effect added!");
// };
// const pakBoundryLayer = () => {
//     const sourceId = "pakistanBoundry";
//     const layerId = "pak-layer-network";

//     map.current.addSource(sourceId, {
//         type: "geojson",
//         data: completePakistanPolygonData,
//     });

//     map.current.addLayer({
//         id: layerId,
//         type: "line",
//         source: sourceId,
//         layout: {
//             "line-join": "round",
//             "line-cap": "round",
//         },
//         paint: {
//             "line-color": "#BD1D23",
//             "line-width": 3,
//             "line-opacity": 1,
//         },
//     });

//     let glowStep = 0;
//     function animateGlow() {
//         let opacity = 0.5 + Math.sin(glowStep) * 0.5; // Sine wave effect
//         map.current.setPaintProperty(layerId, "line-opacity", opacity);
//         glowStep += 0.1;
//         requestAnimationFrame(animateGlow);
//     }

//     animateGlow();
//     console.log("Rotating halo glow effect added!");
// };

export const pakBoundryLayer = (map, timeoutRef = null) => {
  if (map) {
    const sourceId = 'pakistanBoundry';
    const layerId = 'pak-layer-network';

    // Clear any existing animation timeout
    if (timeoutRef?.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    if (!map.getSource(sourceId)) {
      map.addSource(sourceId, {
        type: 'geojson',
        data: completePakistanPolygonData,
      });
    }

    if (!map.getLayer(layerId)) {
      map.addLayer({
        id: layerId,
        type: 'line',
        source: sourceId,
        layout: {
          'line-join': 'round',
          'line-cap': 'round',
        },
        paint: {
          'line-color': '#BD1D23',
          'line-width': 3,
          'line-dasharray': [1, 4],
        },
      });
    }

    // Define animateFlicker with safety checks
    const animateFlicker = () => {
      // Check if map still exists and layer is still present
      if (!map || !map.getLayer || !map.getLayer(layerId)) {
        if (timeoutRef) {
          timeoutRef.current = null;
        }
        return; // Stop animation if map or layer is gone
      }

      try {
        const randomOpacity = Math.random() * 0.7 + 0.3;
        map.setPaintProperty(layerId, 'line-opacity', randomOpacity);
      } catch (error) {
        // Silently fail if map is being destroyed
        if (timeoutRef) {
          timeoutRef.current = null;
        }
        return;
      }

      // Schedule next animation frame
      const timeoutId = setTimeout(animateFlicker, Math.random() * 500 + 500);
      if (timeoutRef) {
        timeoutRef.current = timeoutId;
      }
    };

    animateFlicker();
  }
};

export const boundaryLayer = (map, regions, regionsMpbn, tab) => {
  const selectedRegions = tab === 'mpbn' ? regionsMpbn : regions;

  [...regions, ...regionsMpbn].forEach((region) => {
    const fillLayerId = region.id;
    const lineLayerId = `${region.id}-border`;

    if (map.getLayer(lineLayerId)) {
      map.removeLayer(lineLayerId);
    }
    if (map.getLayer(fillLayerId)) {
      map.removeLayer(fillLayerId);
    }
    if (map.getSource(region.id)) {
      map.removeSource(region.id);
    }
  });

  selectedRegions.forEach((region) => {
    const lineLayerId = `${region.id}-border`;
    const fillLayerId = region.id;

    map.addSource(region.id, {
      type: 'geojson',
      data: region.data,
    });

    if (region.regionName !== 'Pakistan') {
      map.addLayer({
        id: fillLayerId,
        type: 'fill',
        source: region.id,
        paint: {
          'fill-color': region.color,
          'fill-opacity': 0.7,
        },
      });
    } else {
      map.addLayer({
        id: lineLayerId,
        type: 'line',
        source: region.id,
        paint: {
          'line-color': '#446363',
          'line-width': 2,
          'line-opacity': 0.7,
        },
      });
    }
  });
};
